export const config = {
    name: 'New tag',
};
